
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3510_2748)"}},[_c('path',{attrs:{"d":"M15.334 13.445L9.877 7.987l5.457-5.449L13.446.667 7.99 6.119 2.541.667.666 2.54l5.457 5.464L.667 13.46l1.873 1.873L8.01 9.872l5.453 5.461 1.872-1.888z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3510_2748"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    